import AGREGAR_LICITACION from '@/graphql/mutations/administracion/licitaciones/agregarLicitacion.gql';
import ACTUALIZAR_LICITACION from '@/graphql/mutations/administracion/licitaciones/actualizarLicitacion.gql';
import REMOVER_LICITACION from '@/graphql/mutations/administracion/licitaciones/removerLicitacion.gql';
import LICITACIONES from '@/graphql/querys/administracion/licitaciones/licitaciones.gql';

export default {
  methods: {
    async mixAgregarLicitacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_LICITACION,
        variables: {
          licitacion: this.licitacion,
        },
        update: (store, { data: { agregarLicitacion } }) => {
          const data = store.readQuery({ query: LICITACIONES });
          data.licitaciones.push(agregarLicitacion);
          store.writeQuery({ query: LICITACIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarLicitacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_LICITACION,
        variables: {
          id: this.licitacionEditar.id,
          licitacion: this.licitacion,
        },
        update: (store, { data: { actualizarLicitacion } }) => {
          const data = store.readQuery({ query: LICITACIONES });
          const { licitaciones } = data;
          const index = licitaciones
            .findIndex((licitacion) => licitacion.id === actualizarLicitacion);
          if (index !== -1) {
            licitaciones.splice(index, 1, actualizarLicitacion);
          }
          store.writeQuery({ query: LICITACIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarLicitacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_LICITACION,
        variables: {
          id: this.licitacionEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: LICITACIONES });
          const { licitaciones } = data;
          const index = licitaciones
            .findIndex((licitacion) => licitacion.id === this.licitacionEliminar.id);
          if (index !== -1) {
            licitaciones.splice(index, 1);
          }
          store.writeQuery({ query: LICITACIONES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
